const stickyFilterSortingMockValue = 'Filtres & Tri : nos suggestions';

export const StickyFilterSortingSection = () => {
    return (
        <section id={'product-list-sticky-filter-sorting-section'} className={'py-0.5  desktopS:hidden'}>
            <div className={'p-1 bg-background-skeleton'}>{stickyFilterSortingMockValue}</div>
        </section>
    );
};
